import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import VehiclesDTO from '../../../../dto/VehiclesDTO';
import { VEHICLE_STATUS_LIST } from '../../../../configs';
import CustomSelectInput from '../../../../components/fields/SelectInput/CustomSelectInput';

export default function VehicleFrom(props) {
  const { control, formMeta } = props;
  const dto = new VehiclesDTO();
  const attributes = dto.getAttributesByName();

  return (
    <>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_external_id}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_brand}
          variant="material"
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_model}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_registry_number}
          variant="material"
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_lpn}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_vin}
          variant="material"
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.carrier_external_id}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_color}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          component={CustomSelectInput}
          dtoObject={attributes.vehicle_status}
          options={VEHICLE_STATUS_LIST}
          withLabel
          variant="material"
          placeholder=""
        />
      </Row>
    </>
  );
}
